import { UUID } from "crypto";


export interface ListOfVacancy {
    vacancies: Vacancy[];
    totalData: number;
}

export interface Vacancy {
    id: UUID;
    blobId: UUID;
    title: string;
    businessUnitId: UUID;
    businessUnitName: string;
    categoryName: string;
    city: string;
    endDate: Date;
}

export interface IVacancyDetail {
    id: UUID;
    businessUnitId: UUID;
    title: string;
    city: string;
    company: string;
    deadline: Date;
    category: string;
    requirements: string[];
    jobDesc: string[];
    aboutBusinessUnit: string;
}

export interface PaginatedVacancyProps {
    data: Vacancy[];
    setPopup: (popupName: PopupTypes, value: boolean) => void;
    setSelectedItem: (item: Vacancy | null) => void;
}

export enum PopupTypes {
    ShowJobApply = 'showJobApply',
    ShowErrorPopup = 'showErrorPopup',
    ShowSuccessPopup = 'showSuccessPopup',
}

export interface PopupState {
    [PopupTypes.ShowJobApply]: boolean;
    [PopupTypes.ShowErrorPopup]: boolean;
    [PopupTypes.ShowSuccessPopup]: boolean;
}